import React, { useState } from "react";
import {
    Radio,
    Button,
    Typography,
    Dialog,
    DialogBody,
    DialogHeader,
    DialogFooter,
} from "@material-tailwind/react";
import InputMask from "react-input-mask";

function CardSelection({ cards, onCardSelect, onAddCard }) {
    const [selectedCard, setSelectedCard] = useState(null);
    const [openAddCardDialog, setOpenAddCardDialog] = useState(false);
    const [newCardDetails, setNewCardDetails] = useState({
        cardNumber: "",
        expiration: "",
        cvv: "",
        cardholderName: "",
    });

    const handleInputChange = (field, value) => {
        setNewCardDetails({
            ...newCardDetails,
            [field]: value,
        });
    };

    const handleAddCard = () => {
        onAddCard(newCardDetails);
        setNewCardDetails({
            cardNumber: "",
            expiration: "",
            cvv: "",
            cardholderName: "",
        });
        setOpenAddCardDialog(false);
    };

    return (
        <div className="w-full p-4">
            <Typography variant="h5" className="mb-4">
                Selecciona una tarjeta:
            </Typography>
            {cards.length > 0 ? (
                <div className="space-y-4">
                    {cards.map((card) => (
                        <div className="flex">
                            <Radio
                                key={card.id}
                                id={card.id}
                                name="selectedCard"
                                label={`**** **** **** ${card.last4}`}
                                value={card.id}
                                checked={selectedCard === card.id}
                                onChange={(e) => {
                                    setSelectedCard(e.target.value);
                                    onCardSelect(e.target.value);
                                }}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <Typography color="gray">
                    No hay tarjetas disponibles. Agrega una nueva tarjeta.
                </Typography>
            )}
            <Button
                variant="outlined"
                color="blue"
                className="mt-4"
                onClick={() => setOpenAddCardDialog(true)}
            >
                Agregar nueva tarjeta
            </Button>

            <Dialog
                open={openAddCardDialog}
                handler={() => setOpenAddCardDialog(!openAddCardDialog)}
            >
                <DialogHeader>Agregar nueva tarjeta</DialogHeader>
                <DialogBody className="space-y-4">
                    <div>
                        <label htmlFor="cardNumber" className="block text-gray-700">
                            Número de tarjeta
                        </label>
                        <InputMask
                            mask="9999 9999 9999 9999"
                            value={newCardDetails.cardNumber}
                            onChange={(e) => handleInputChange("cardNumber", e.target.value)}
                            placeholder="Ingresa el número de tarjeta"
                            className="w-full px-3 py-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label htmlFor="expiration" className="block text-gray-700">
                            Fecha de expiración (MM/AA)
                        </label>
                        <InputMask
                            mask="99/99"
                            value={newCardDetails.expiration}
                            onChange={(e) => handleInputChange("expiration", e.target.value)}
                            placeholder="MM/AA"
                            className="w-full px-3 py-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label htmlFor="cvv" className="block text-gray-700">
                            CVV
                        </label>
                        <InputMask
                            mask="999"
                            value={newCardDetails.cvv}
                            onChange={(e) => handleInputChange("cvv", e.target.value)}
                            placeholder="CVV"
                            className="w-full px-3 py-2 border rounded-md"
                        />
                    </div>
                    <div>
                        <label htmlFor="cardholderName" className="block text-gray-700">
                            Nombre del titular
                        </label>
                        <input
                            type="text"
                            value={newCardDetails.cardholderName}
                            onChange={(e) => handleInputChange("cardholderName", e.target.value)}
                            placeholder="Nombre del titular"
                            className="w-full px-3 py-2 border rounded-md"
                        />
                    </div>
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={() => setOpenAddCardDialog(false)}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="gradient"
                        color="green"
                        onClick={handleAddCard}
                    >
                        Agregar tarjeta
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
}

export default CardSelection;
